import {
  AccountProfile,
  KeycloakAccount,
  KeycloakUserAttributes,
} from "core/types"

const getAttributeValue = (
  attributes: KeycloakUserAttributes | undefined,
  name: string
): string | null => {
  const value = attributes?.[name]?.[0]?.trim()
  return value ? value : null
}

export const toAccountProfile = (account: KeycloakAccount): AccountProfile => ({
  id: account.id,
  email: account.email ?? "",
  firstName: account.firstName ?? "",
  lastName: account.lastName ?? "",
  preferredName: getAttributeValue(account.attributes, "preferredName") ?? "",
  dateOfBirth: getAttributeValue(account.attributes, "dateOfBirth"),
})

export const fullName = (profile: AccountProfile): string =>
  [profile.firstName, profile.lastName].filter(Boolean).join(" ")

/**
 * Initials for the account avatar. Falls back to the email's first character
 * so the avatar is never blank for accounts with no name set.
 */
export const initials = (profile: AccountProfile): string => {
  const fromName = [profile.firstName, profile.lastName]
    .map((part) => part.trim().charAt(0))
    .filter(Boolean)
    .join("")

  const value = fromName || profile.email.trim().charAt(0)
  return value.toUpperCase()
}
